__webpack_require__.p = "/vodolux-pos/";